/*
*
* Refund constants
*  make by phamthainb
*/

export const GET = 'Refund/GET';
export const PAGINATION = 'Refund/PAGINATION'
export const SEARCH = 'Refund/SEARCH'